import { Suspense } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { log, GenericErrorScreen } from '@ptth-web/shared-module';
import ErrorIllustration from 'assets/error-illustration.svg';

import { useOnlineStatus } from '@leagueplatform/web-common';
import {
  FullPageError,
  LoadingIndicator,
} from '@leagueplatform/web-common-components';
import { LeagueProvider } from '@leagueplatform/core';
import { ObservabilityErrorBoundary } from '@leagueplatform/observability';

import { initMasonryRegistry } from 'utils/init-masonry-registry';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { config } from 'config';
import { appRoutes } from 'app-routes';

initMasonryRegistry();

log('test message');

const LeagueProviderWrapper = () => {
  const { isOffline, isOnline } = useOnlineStatus();
  return (
    <LeagueProvider config={config}>
      <ObservabilityErrorBoundary
        fallback={
          <GenericErrorScreen
            illustration={ErrorIllustration}
            onButtonClick={() => window.location.reload()}
          />
        }
        errorContext={{
          context: { Context: { location: 'Root App ErrorBoundary' } },
        }}
      >
        <Suspense fallback={<LoadingIndicator />}>
          {isOffline && (
            <FullPageError error={null} route={APP_MANAGED_ROUTES.HOME} />
          )}
          {isOnline && <Outlet />}
        </Suspense>
      </ObservabilityErrorBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </LeagueProvider>
  );
};

const router = createBrowserRouter([
  {
    element: <LeagueProviderWrapper />,
    children: appRoutes,
  },
]);

export const App = () => <RouterProvider router={router} />;
